import { render } from "./pdfView.vue?vue&type=template&id=739cfbce&scoped=true"
import script from "./pdfView.vue?vue&type=script&lang=js"
export * from "./pdfView.vue?vue&type=script&lang=js"

import "./pdfView.vue?vue&type=style&index=0&id=739cfbce&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739cfbce"]])

export default __exports__